import {FeaturesEnum} from 'presentation/constants';
import {useFeatureFlagsQuery} from 'presentation/queries/useFeatureFlagsQuery';

export function useFeatureFlag(flagName: FeaturesEnum) {
	const {data: featureFlags} = useFeatureFlagsQuery();
	const featureFlag = featureFlags?.find(flag => flag?.flag === flagName);

	return {
		isEnabled: featureFlag?.enabled ?? false,
	};
}
